import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Grid, Box, Typography, FormControl, RadioGroup, FormControlLabel, Radio } from '@material-ui/core'


import useStyles from './styles'

export default function JobTitleSelectionStep2(props) {
    
    const classes = useStyles()
    const [jobGroup, setJobGroup] = useState('')
    
    const handleJobGroupSelection = (e) => {
        setJobGroup(e.target.value)
    }

    const handleNext = () => {
        // selectedFuntionIndex, selectedGroupIndex
        const values = jobGroup.split('_')
        props.onGroupSelection({
            selectedFunctionIndex: values[0],
            selectedGroupIndex: values[1],
        })
    }


    return (
        <>
            <Grid container>
                <Grid item xs={10}>
                    <Typography gutterBottom>
                        Please Choose the Group which most likely fit for your job
                    </Typography>
                </Grid >
                <Grid item xs={2}>
                    <Button disabled={!jobGroup} variant="contained" color="primary" onClick={handleNext}>
                        Next
                    </Button>
                </Grid>
            </Grid>
            
            <Box m={2} display="flex" justifyContent="center">
                <FormControl
                    component="fieldset"
                    className={classes.formControl}
                >
                    <RadioGroup
                        aria-label="choose"
                        name="jobGroup"
                        value={jobGroup}
                        onChange={handleJobGroupSelection}
                    >
                        {
                            props.groups.map((group, i) => 
                                <React.Fragment key={i}>
                                    <Typography
                                        className={classes.boldtext}
                                        gutterBottom
                                        key={`g${i}`}
                                    >
                                        {group.job_function}
                                    </Typography>
                                    {
                                        group.jobs.map((job, j) => 
                                            <FormControlLabel
                                                className={classes.jobRadio}
                                                key={`j${j}`}
                                                value={`${i}_${j}`}
                                                control={<Radio color="primary" />}
                                                label={`${job.job_title}`}
                                            />
                                        )
                                    }
                                </React.Fragment>
                            )
                        }
                    </RadioGroup>
                </FormControl>
            </Box>
        </>
    )
}

JobTitleSelectionStep2.propTypes = {
    onGroupSelection: PropTypes.func.isRequired,
    groups: PropTypes.array.isRequired,
}
